import React from 'react';
import PropTypes from 'prop-types';
import MoneyDisplay from '../../../../components/money-display';

function AmountCellRenderer(props) {
  return (
    <div>
      <MoneyDisplay value={props.value} precision={2} abbreviated />
    </div>
  );
}

AmountCellRenderer.propTypes = {
  value: PropTypes.number,
};
AmountCellRenderer.defaultProps = {
  value: null,
};

export default AmountCellRenderer;
